// Copyright (c) 2021 Davide Gironi
// Please refer to LICENSE file for licensing information.

import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import ReactLoading from 'react-loading';

export default function Loading() {

    const type = "spin";

    return (
        <Container style={{ height: "100vh" }} >
            <Row className="align-items-center" style={{ height: "100vh" }}>
                <Col className="justify-content-md-center" style={{ display: "flex" }} >
                    <ReactLoading type={type} color={"black"} height={30} width={30} />
                </Col>
            </Row>
        </Container>
    );
}
